import { createSelector } from 'reselect';
import { CompaniesPieColorsState } from 'slices/modules/companies/companiesPieColors';
import { RootState } from 'store';

export const companiesPieColorsSelector = createSelector(
  (state: RootState): CompaniesPieColorsState => state.companiesPieColors,
  (data) => data.pieColors
);
